import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

export const usePatientPreferences = (patientId) => {
  const currentPatientId = useCurrentPatientId();
  const selectedPatientId = patientId || currentPatientId;
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientPreferences", tenantVal, selectedPatientId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientpreferences/getbypatientid/${selectedPatientId}`
      );
      return response?.data?.at(-1) ?? null;
    },
    enabled: !!tenantVal && !!selectedPatientId,
  });
};
